<div class="logo-section d-grid gap-3">
  <div class="row mt-0">
    <div
      class="col-lg-8"
      [class.text-center]="!isEssent()"
      [class.offset-lg-2]="!isEssent()"
    >
      <h2 class="contact-section__title" *scText="title()"></h2>
      @if (showIntroduction() && introduction(); as introduction) {
        <div class="contact-section__introduction" *scText="introduction"></div>
      }
    </div>
  </div>

  <ul
    class="row row-cols-1 row-cols-sm-2 list-unstyled -mt-3 mb-0 gx-4 gy-3"
    [ngClass]="getLogoCols()"
  >
    @for (logo of logos(); track uid() + $index) {
      @if (logo.image; as image) {
        <li class="d-flex align-items-center justify-content-center col mb-0">
          @if (logo.link; as link) {
            <a
              *wlGenericLink="link"
              wlTrackLink
              [trackLinkInfo]="{
                rendering: { componentName: 'LogoSectionComponent' },
                field: link.value || '',
                eventType: 'button-click',
                type: 'button',
              }"
              trackImpression="button-impression"
              [attr.title]="link.value?.text"
            >
              <ng-container [ngTemplateOutlet]="imageTemplate" />
            </a>
          } @else {
            <ng-container [ngTemplateOutlet]="imageTemplate" />
          }
          <ng-template #imageTemplate>
            <img *scImage="image" class="img-fluid" />
          </ng-template>
        </li>
      }
    }
  </ul>
</div>
